export default __webpack_public_path__ + "static/media/_ic_sun.4f93f613.svg";